import { getAnalysisSubtitle } from '@modules/analysis/helpers';
import { useAnalysisStore } from '@modules/analysis/store/analysisStore';
import { AnalysisUseCase, AnalysisViewFragment } from 'generated/graphql';
import { useDeepCompareEffect } from 'react-use';
import {
  getAnalysisLink,
  getAnalysisRoute,
} from 'v2/core/services/analysis/link';
import { useGetUser } from 'v2/core/services/user';

interface SetAnalysisInQuantifyOptions {
  analysis?: AnalysisViewFragment;
}

export const useSetAnalysisInQuantify = ({
  analysis,
}: SetAnalysisInQuantifyOptions) => {
  const user = useGetUser();
  const { setAnalysis, ...storedAnalysis } = useAnalysisStore();
  useDeepCompareEffect(() => {
    if (!analysis) {
      return;
    }

    const { title, viewToken, editToken, createdBy, updatedAt } = analysis;

    const analysisValues = {
      ...storedAnalysis,
      ...analysis,
      useCase: AnalysisUseCase.Default,
      isEditable: Boolean(editToken),
      subtitle: getAnalysisSubtitle({
        userName: `${createdBy.firstName} ${createdBy.lastName}`,
        updatedAt: updatedAt,
      }),
      href: getAnalysisLink({
        name: title,
        token: viewToken,
        tenantSlug: user.tenant.slug,
        useCase: analysis.useCase,
      }),
      path: getAnalysisRoute({
        name: title,
        token: viewToken,
        useCase: analysis.useCase,
      }),
      tenantID: user.tenant.id,
      title: title ?? `Untitled Analysis`,
      isLoading: false,
    };
    setAnalysis(analysisValues);
  }, [
    analysis,
    storedAnalysis,
    user.firstName,
    user.id,
    user.lastName,
    user.tenant.id,
    user.tenant.slug,
  ]);
};
